import React from 'react';

import styles from './UseHare.module.scss';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { useAxios } from '../../../../../../AxiosHandler';
import { useAuth } from '../../../../../../Auth';
import LineGraphCard from '../../../Cards/LineGraphCard/LineGraphCard';

function UseHare(props: UseHareProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = React.useState<any>();

    const options = {
        scales: {
            y: {
                suggestedMin: 0,
                suggestedMax: 5
            }
        },
        plugins: {
            legend: {
                display: false
            }
        }
    };

    function getData() {
        if (auth.selectedBreed == undefined) return;

        const requests = [
            {
                method: 'get',
                url: "/api/statistics/use/hare/" + auth.selectedBreed + "/avgyear",
                responseType: 'json',
                headers: {'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all"}
            }
        ];
        Promise.all(requests.map((request) => axios.single(request))).then((res) => {
            if (res[0].data?.length > 0) {

                setData({
                    avgyear: {
                        JAKTLYST: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.JAKTLYST) },
                        SAMARBEID: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.SAMARBEID) },
                        FOTARBEID: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.FOTARBEID) },
                        MAALBRUK_FOT: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.MAALBRUK_FOT) },
                        MAALBRUK_TAP: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.MAALBRUK_TAP) },
                        ARBEID_LOS: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.ARBEID_LOS) },
                        ARBEID_TAP: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.ARBEID_TAP) },
                        MAAL_NYANSERING: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.MAAL_NYANSERING) },
                        MAAL_HORBARHET: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.MAAL_HORBARHET) },
                        LYDIGHET: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.LYDIGHET) },
                        KONDISJON: { labels: res[0].data.map((item: any) => item.YEAR), data: res[0].data.map((item: any) => item.KONDISJON) },
                    },
                });

                props.onDataLoaded?.(true);
            } else {
                setData(undefined);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    React.useEffect(() => {
        if (auth.selectedBreed != undefined) {
            props.onDataLoaded?.(false);
            getData();
        }
    }, [auth.selectedBreed, auth.selectedCountry]);

    return (
        <div className={styles.statisticsusehare}>
            <Container className={styles.container}>
                <Row className={styles.row}>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.JAKTLYST.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.JAKTLYST.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.jaktlyst.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.jaktlyst.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.SAMARBEID.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.SAMARBEID.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.samarbeid.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.samarbeid.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.FOTARBEID.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.FOTARBEID.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.fotarbeid.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.fotarbeid.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.MAALBRUK_FOT.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.MAALBRUK_FOT.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.maalbruk_fot.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.maalbruk_fot.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.MAALBRUK_TAP.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.MAALBRUK_TAP.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.maalbruk_tap.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.maalbruk_tap.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.ARBEID_LOS.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.ARBEID_LOS.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.arbeid_los.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.arbeid_los.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.ARBEID_TAP.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.ARBEID_TAP.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.arbeid_tap.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.arbeid_tap.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.MAAL_NYANSERING.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.MAAL_NYANSERING.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.maal_nyansering.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.maal_nyansering.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.MAAL_HORBARHET.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.MAAL_HORBARHET.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.maal_horbarhet.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.maal_horbarhet.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.LYDIGHET.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.LYDIGHET.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.lydighet.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.lydighet.graph.description")}
                        />
                    </Col>
                    <Col sm="12" md="6" className={styles.col}>
                        <LineGraphCard
                            data={{
                                labels: data?.avgyear.KONDISJON.labels,
                                datasets: [{
                                    backgroundColor: "transparent",
                                    pointBackgroundColor: "#68DB5A",
                                    borderColor: "#68DB5A",
                                    pointRadius: 2,
                                    data: data?.avgyear.KONDISJON.data,
                                    tension: 0.3
                                }]
                            }}
                            options={options}
                            title={t("statistics.areas.use.hare.avgyear.kondisjon.graph.title")}
                            description={t("statistics.areas.use.hare.avgyear.kondisjon.graph.description")}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

class UseHareProps {
    onDataLoaded?: (hasData: boolean) => void;
}

export default UseHare;